<template>
  <AccountingPage title="Encaissements">
    <CollectionForAccountingTable/>
  </AccountingPage>
</template>

<script>
import AccountingPage from "@/accounting/components/AccountingPage.vue";
import CollectionForAccountingTable from "@/accounting/components/tables/CollectionForAccountingTable.vue";

export default {
  name: 'CollectionView',
  components: {
    CollectionForAccountingTable,
    AccountingPage,
  },
}
</script>
